import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {StocksService} from '../../../core/services/gestion-stock/stocks.service';
import {UtilsService} from '../../../core/utils/utils.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {SearchSupplierWrapper} from '../../../core/suppliers/wrappers/search-supplier-wrapper';
import {ModelViewInventaire} from './model-view-inventaire';
import {ProduitDeclinaisonService} from '../../../core/services/entities/produit-declinaison.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {ToastService} from "../../../core/services/technique/toast.service";
import {DxAccordionComponent, DxLoadPanelComponent} from "devextreme-angular";
import {ImageBase64DTO} from "../../../core/dtos/images/ImageBase64DTO";
import {AccordionInventaireService} from "../../../core/services/gestion-stock/accordion-inventaire.service";
import { ButtonThemeEnum } from "app/shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-inventaire',
    templateUrl: './inventaire.component.html',
    styleUrls: ['./inventaire.component.scss'],
    standalone: false
})
export class InventaireComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;
  displayDialogAjoutLot: boolean;

  subResultSearchStocks: Subscription;
  subAccordionInventaireAction: Subscription;
  subRoute: Subscription;
  subTriggerPrint: Subscription;

  lignesInventaire: ModelViewInventaire[];
  totalDenrees = 0;
  totalLots = 0;
  selectedInventaire: ModelViewInventaire;
  selectedLot: ModelViewInventaire;

  isSaveDisabled = true;

  // criteres de recherhce du panneau gauche (module gestion de stocks)
  ssw: SearchSupplierWrapper;

  timer: any;

  cols: any[] = [
    {field: 'denree', header: 'Lot'},
    {field: 'code', header: 'Code'},
    {field: 'zdsLibelle', header: 'Zone de stockage'},
    {field: 'dateEntree', header: 'Réceptionné le'},
    {field: 'dlc', header: 'DLC'},
    {field: 'uniteDeStockage', header: 'U.S'},
    {field: 'quantite', header: 'Qté'},
    {field: 'quantiteReaj', header: 'Qté Réaj'}
  ];

  feature: string;

  page: any = 1;
  pageSize: any = 50;

  private isKeepCloseDialogConfirmSave: boolean = false;

  isImagePopupOpened: boolean;

  @ViewChild(DxAccordionComponent, {static: false}) accordion: DxAccordionComponent;
  @ViewChild('load', {static: false}) load: DxLoadPanelComponent;

  loadingVisible = false;
  loaderMessage: string;
  selectedItems: any[] = [];
  isWaitingForHistoryParams: boolean = false;
  displayDialogPrintInventaire: boolean = false;
  private inventaireDate: Date | null = null;

  constructor(
    public elementRef: ElementRef,
    private route: ActivatedRoute,
    private stocksSvc: StocksService,
    private produitDeclinaisonSvc: ProduitDeclinaisonService,
    public utils: UtilsService,
    public accordionInventaireSvc: AccordionInventaireService,
    private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.subTriggerPrint = this.stocksSvc.triggerPrint$.subscribe( (_: boolean) =>{
      this.displayDialogPrintInventaire = true;
    });

    // notifier le composant de recherche qu'on ait sur la fonctionnalité
    this.subRoute = this.route.url.subscribe(response => {
      this.feature = response[0].path;
      this.stocksSvc.announceFeature(this.feature, this.page, this.pageSize);
    });

    this.stocksSvc.inventaireLoading$.subscribe(loading => {
      this.loaderMessage = loading ? 'Chargement en cours...' : '';
      this.loadingVisible = loading;
    });

    // s'abonner à la recherche des articles dans le stock
    this.subResultSearchStocks = this.produitDeclinaisonSvc.resultSearchStocksForInventaire$
      .subscribe(response => {
        this.loadingVisible = false;
        this.lignesInventaire = response.resultList;
        this.ssw = new SearchSupplierWrapper();
        this.ssw.filtersMap = response?.additionalProperties['filters'];
        this.totalDenrees = response?.additionalProperties['totalDenrees'] ? response.additionalProperties['totalDenrees'] : 0;
        this.totalLots = response?.additionalProperties['totalLots'] ? response.additionalProperties['totalLots'] : 0;
        this.initPagination();
      });

    // dialog confirm keep openable
    this.stocksSvc.isKeepItClose$.subscribe((response: boolean) => {
      this.isKeepCloseDialogConfirmSave = response;
    });

    // si l utilsateur annule son save le btn save reste clickable
    this.stocksSvc.isConfirmCancelled$.subscribe((reponse: boolean) => {
      this.isSaveDisabled = !reponse;
    });

    this.subAccordionInventaireAction = this.accordionInventaireSvc.accordionInventaireAction$.subscribe(shouldExpand => {
      if (shouldExpand) {
        this.expendAccordion();
      } else {
        this.collapseAccordion();
      }
    });

    this.stocksSvc.waitingForHistoryParams$.subscribe(waiting => {
      this.isWaitingForHistoryParams = waiting;
    });

    this.stocksSvc.inventaireDate$.subscribe(date => {
      this.inventaireDate = date;
    });
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subResultSearchStocks);
    this.utils.unsubscribe(this.subRoute);
    this.utils.unsubscribe(this.subTriggerPrint);
    this.utils.unsubscribe(this.subAccordionInventaireAction);
  }

  initPagination = () => {
    this.page = this.ssw?.filtersMap?.page ? this.ssw.filtersMap.page : 1;
    this.pageSize = this.ssw?.filtersMap?.size ? this.ssw.filtersMap.size : 50;
  }

  openDialogAjoutLot = (selectedInventaire: ModelViewInventaire, $event: any) => {
    $event.stopPropagation();
    this.displayDialogAjoutLot = true;
    this.selectedInventaire = selectedInventaire;
    this.produitDeclinaisonSvc.announceOpenDialogAjoutLot(null, this.selectedInventaire);
  };

  updateQuantityReaj = ($event: any, child: ModelViewInventaire): void => {
    if ($event >= 0) {
      clearTimeout(this.timer);
      child.quantiteReaj = $event;
      child.dateEntree = this.inventaireDate ?? null;
      this.timer = setTimeout(() => {
        this.stocksSvc.saveInventaire([child]).subscribe(async response => {
          if (!this.utils.isResponseSupplierError(response)) {
            this.stocksSvc.announceFeature(this.feature, this.page, this.pageSize);
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Les modifications ont été enregistrées avec succès`);
            this.isSaveDisabled = true;
            await this.accordion.instance.collapseItem(this.selectedInventaire.id);
          }
        });
      }, 1500);
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `La quantité réajustée doit être supérieure ou égale à 0`);
    }
  };

  updateQteLotsInventaire = ($event: any, inventaire: ModelViewInventaire) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      inventaire.dateEntree = this.inventaireDate ?? null;
      this.stocksSvc.updateQteLotsInventaire(inventaire, $event).subscribe(async response => {
        if (!this.utils.isResponseSupplierError(response)) {
          this.stocksSvc.announceFeature(this.feature, this.page, this.pageSize);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Les modifications ont été enregistrées avec succès`);
          await this.accordion.instance.collapseItem(this.selectedInventaire.id);
        }
      });
    }, 1500);
  }

  onClick = ($event: any, inventaire: ModelViewInventaire) => {
    this.selectedInventaire = inventaire;
    $event.stopPropagation();
  }


  handlePageChange = (page: number) => {
    if (page === this.page) return;
    this.page = page;
    this.produitDeclinaisonSvc.announcePaginationSearchStock({page: this.page - 1, size: this.pageSize});
  };

  handlePageSizeChange = (size: number) => {
    if (size === this.pageSize) return;
    this.pageSize = size;
    this.page = 1;
    this.produitDeclinaisonSvc.announcePaginationSearchStock({page: 0, size});
  };

  getLotToDisplay = (child: ModelViewInventaire): String => {
    return child.lotArticleFournisseur ? child.lotArticleFournisseur : child.lotArticle;
  };

  onImagePopupClose(images: ImageBase64DTO[]) {
    this.isImagePopupOpened = false;
  }

  isImageButtonAvailable(data: ModelViewInventaire) {
    return data?.images?.length > 0;
  }

  openImageDialog(data: ModelViewInventaire) {
    this.selectedLot = data;
    this.isImagePopupOpened = true;
  }

  getImageCount(data: ModelViewInventaire) {
    if (data?.images?.length > 0)
      return " x " + data?.images?.length;
    return null;
  }


  collapseAccordion = () => {
    this.loaderMessage = "Fermeture en cours...";
    this.loadingVisible = true;

    setTimeout(() => {
      this.selectedItems = [];
      this.loadingVisible = false;

      setTimeout(() => {
        const instance = this.accordion.instance;
        this.loadingVisible = false;
        instance.option("animationDuration", 300);
      }, 100);
    }, 50);
  };

  expendAccordion = () => {
    this.loaderMessage = "Déploiement en cours...";
    this.loadingVisible = true;

    setTimeout(() => {
      const instance = this.accordion.instance;
      instance.beginUpdate();
      instance.option("animationDuration", 0);
      this.selectedItems = [...instance.option("items")];
      instance.endUpdate();

      setTimeout(() => {
        this.loadingVisible = false;
        instance.option("animationDuration", 300);
      }, 100);
    }, 50);
  }
}
